import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { X, ArrowLeft, ArrowRight, CheckCircle } from '@phosphor-icons/react';

function ReviewMistakes({ incorrectQuestions, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const nextQuestion = () => {
    if (currentIndex < incorrectQuestions.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setIsFlipped(false);
    }
  };

  const prevQuestion = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setIsFlipped(false);
    }
  };

  const currentQuestion = incorrectQuestions[currentIndex];

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-2xl">
        <CardContent className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-gray-900">틀린 문제 복습</h2>
            <Button variant="ghost" size="icon" onClick={onClose} className="rounded-full">
              <X size={24} />
            </Button>
          </div>

          <div className="mb-4 text-center">
            <p className="text-sm text-gray-600">
              {currentIndex + 1} / {incorrectQuestions.length}
            </p>
          </div>

          <div className="card-container mb-6 hover:shadow-lg cursor-pointer" onClick={handleCardFlip}>
            <div className={`card-inner ${isFlipped ? 'is-flipped' : ''}`}>
              <div className="card-front">
                <div className="text-2xl font-bold text-center text-white m-4">
                  {currentQuestion.question}
                </div>
              </div>
              <div className="card-back p-8">
                {currentQuestion.isMultipleChoice ? (
                  <div className="space-y-3">
                    <div className="text-xl font-bold text-center text-white mb-4">정답:</div>
                    {currentQuestion.answerOptions.map((option, idx) => (
                      <div
                        key={idx}
                        className={`flex items-center gap-3 p-3 rounded-xl ${currentQuestion.correctAnswers.includes(idx)
                          ? 'bg-green-100 border-2 border-green-500'
                          : 'bg-gray-50/20'
                          }`}
                      >
                        <div className={`w-6 h-6 flex-shrink-0 rounded-full border-2 flex items-center justify-center ${currentQuestion.correctAnswers.includes(idx)
                          ? 'border-green-500 bg-green-500'
                          : 'border-gray-300'
                          }`}>
                          {currentQuestion.correctAnswers.includes(idx) && (
                            <CheckCircle size={16} weight="fill" className="text-white" />
                          )}
                        </div>
                        <span className={`text-lg ${currentQuestion.correctAnswers.includes(idx)
                          ? 'text-green-800 font-medium'
                          : 'text-white'
                          }`}>
                          {option}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-2xl font-bold text-center text-white m-4">
                    {currentQuestion.answer}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-between gap-2">
            <Button
              onClick={prevQuestion}
              variant="outline"
              disabled={currentIndex === 0}
              className="flex-1"
            >
              <ArrowLeft size={18} className="mr-2" weight="bold" /> 이전
            </Button>
            <Button
              onClick={nextQuestion}
              disabled={currentIndex === incorrectQuestions.length - 1}
              className="flex-1"
            >
              다음 <ArrowRight size={18} className="ml-2" weight="bold" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default ReviewMistakes;